const breakpoints = {
    mobile: 768,
    desktop: 1024,
};

export default breakpoints;
